import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class dietDisease {
     private subject = new Subject<any>();
    sendDisease(message: string) {
        this.subject.next(message);
    }
    clearDisease() {
        this.subject.next();
    }
    getDisease(): Observable<any> {
        return this.subject.asObservable();
    }
}